<template>
  <form @submit.prevent="submit" class="p-t-15" role="form" novalidate="novalidate">
    <div class="m-b-20 form-group form-group-default required">
      <label>{{ $t("models.time_code.name") }}</label>
      <input v-model="timeCode.name" v-validate="'required'" name="name" :data-vv-as="$t('models.time_code.name')" type="text" class="form-control" required="">
    </div>
    <transition name="slide-fade">
     <label v-show="errors.has('name')" id="name-error" class="error" for="name">{{ errors.first('name') }}</label>
    </transition>

    <div class="form-group row">
      <label class="m-t-10 col-md-4 control-label">{{ $t('models.time_code.start_time') }}</label>
      <div class="col-md-8">
        <time-picker v-validate="{ required: true, regex: TimeFormatRegex }" name="start_time" :data-vv-as="$t('models.time_code.start_time')" :value="timeCode.start_time" @input="updateStartTime" />      </div>
    </div>
    <transition name="slide-fade">
      <label v-show="errors.has('start_time')" id="start_time-error" class="error" for="start_time">{{ errors.first('start_time') }}</label>
    </transition>

    <div class="form-group row">
      <label class="m-t-10 col-md-4 control-label">{{ $t('models.time_code.end_time') }}</label>
      <div class="col-md-8">
        <time-picker v-validate="{ required: true, regex: TimeFormatRegex }" name="end_time" :data-vv-as="$t('models.time_code.end_time')" :value="timeCode.end_time" @input="updateEndTime" />
      </div>
    </div>
    <transition name="slide-fade">
      <label v-show="errors.has('end_time')" id="end_time-error" class="error" for="end_time">{{ errors.first('end_time') }}</label>
    </transition>

    <div class="form-group row">
      <label class="m-t-10 col-md-4 control-label">{{ $t('models.time_code.effective_work_minutes') }}</label>
      <div class="col-md-8">
        <duration-time-input v-model="timeCode.effective_work_minutes" :show-icon="true" />
      </div>
    </div>
    <transition name="slide-fade">
     <label v-show="errors.has('effective_work_minutes')" id="effective_work_minutes-error" class="error" for="effective_work_minutes">{{ errors.first('effective_work_minutes') }}</label>
    </transition>

    <div class="d-flex align-items-center justify-content-end">
      <router-link :to="{ name: 'TimeCodes', params: { entity_id: this.entityId } }" class="btn btn-default btn-cons m-t-10">{{ $t("buttons.cancel") }}</router-link>
      <button type="submit" class="btn btn-primary btn-cons m-t-10">{{ $t("buttons.validate") }}</button>
    </div>
  </form>
</template>

<script>
import { TimeFormatRegex } from '@/settings/regex'
import DurationTimeInput from './DurationTimeInput'
import TimePicker from '@/components/pages/TimePicker'

export default {
  name: 'TimeCodeForm',
  components: {
    DurationTimeInput,
    TimePicker
  },
  props: ['timeCode'],
  computed: {
    isEditForm () {
      return !!this.timeCode.id
    },
    actionName () {
      return this.isEditForm ? 'timeCodes/update' : 'timeCodes/create'
    },
    entityId(){
      return this.$route.params.entity_id;
    },
    TimeFormatRegex(){
      return TimeFormatRegex
    }
  },
  methods: {
    submit(){
      var self = this;
      this.$validator.validateAll().then((result) => {
        if(result){
          self.$store.dispatch(this.actionName, this.timeCode).then((timeCode) => {
            self.resetForm()
            self.redirectToListPath()
            self.displaySuccessMessage(timeCode)
          })
          .catch(errorMessage => {
            self.$store.dispatch('message/enable', { type: 'danger', content: errorMessage })
          })
        }
      });
    },
    resetForm(){
      this.$validator.reset();
    },
    redirectToListPath(){
      this.$router.push({ name: 'TimeCodes', params: { entity_id: this.entityId }});
    },
    displaySuccessMessage(timeCode){
      let messageType = this.isEditForm ? 'messages.update_success' :'messages.create_success'
      let successMessage = { type: 'success', content: this.$i18n.t( messageType, {
          'resource': this.$i18n.t('resources.timeCode'),
          'name': timeCode.name
        })
      }
      this.$store.dispatch('message/enable', successMessage)
    },
    updateStartTime(newTime){
      this.$emit('updateStartTime', newTime)
    },
    updateEndTime(newTime){
      this.$emit('updateEndTime', newTime)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/timeCodes/TimeCodeForm.vue